import { Paper, Typography } from "@material-ui/core";
import { ReactNode } from "react";
import { useContentFormStyles } from "./styles";

interface ContentFormProps {
  children: ReactNode;
  label?: string;
}

export default function ContentForm({ children, label }: ContentFormProps) {
  const { classes } = useContentFormStyles();

  return (
    <Paper variant="outlined" className={classes.root}>
      {label && <Typography className={classes.label}>{label}</Typography>}
      {children}
    </Paper>
  );
}
